import type { ModuleTagEntry } from './index';

/** Ultrasound Enhanced Region module tags. */
export const tags: ModuleTagEntry[] = ['SequenceOfUltrasoundRegions'];
